var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRp3Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.1 17.5",
    style: {
      enableBackground: "new 0 0 42.1 17.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00C9FF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,0.3h7.3c0.8,0,1.6,0.1,2.3,0.2c2.3,0.4,4,2.5,3.9,4.9c0,2.4-1.2,4.2-3.4,4.6l4.3,7.1h-6l-3.2-6.4v6.4H0.1 V0.3z M5.3,7.7h0.8c1.3,0,2-0.6,2-1.8c0-1.1-0.6-1.6-1.8-1.6h-1V7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,0.3h6.7c0.8,0,1.5,0,2.3,0.1C26.7,1,28.3,3,28.3,6.2c0,3.8-2,5.7-6,5.7h-2.1v5.2H15V0.3H14.9z M20.2,7.8 h1c1.2,0,1.9-0.6,1.9-1.7c0-1-0.6-1.5-1.8-1.5h-1v3.2H20.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.7,11.3c0.1,1.3,0.6,1.9,1.6,1.9c0.9,0,1.6-0.7,1.7-1.6l0,0c0-0.8-0.7-1.5-1.6-1.4h-0.1 c-0.2,0-0.4,0-0.6,0.1V6.6c0.1,0,0.2,0,0.4,0c0.8,0.1,1.5-0.5,1.6-1.3c-0.1-0.7-0.7-1.2-1.4-1.2c-0.8,0-1.4,0.6-1.4,1.3 c0,0.1,0,0.1,0,0.2v0.1h-4.5c0.2-3.4,2.6-5.4,6.3-5.4c3.4,0,5.8,1.8,5.8,4.4c0,1.2-0.6,2.4-1.7,3c-0.4,0.2-0.8,0.4-1.2,0.4 c1.9,0.1,3.4,1.7,3.3,3.6l0,0c0,3.2-2.8,5.4-6.6,5.4c-2.9,0-5-1-5.9-2.9c-0.5-0.9-0.7-2-0.8-3L33.7,11.3L33.7,11.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRp3Logo);
export default __webpack_public_path__ + "static/media/rp3-logo.57cd1c3d82abbccceecd81ce222d0762.svg";
export { ForwardRef as ReactComponent };